import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { useGameLaunch } from "../../hooks/useGameLaunch";
import { safeFetch } from "../../lib/safeFetch";

const CDN = "https://img.b112j.com/bj/h5/assets";

// Curated "Exclusive Games" featured on the home page — matches the provided reference
export const EXCLUSIVE_FEATURED = [
  {
    id: "golden-genie",
    title: "Golden Genie",
    provider: "FA CHAI",
    img: `${CDN}/images/exclusivegames/default/exclusive-golden-genie.png`,
    fallback: "linear-gradient(135deg,#7c3aed 0%,#a855f7 50%,#ec4899 100%)",
  },
  {
    id: "baji-olympus-1000",
    title: "Maxlive88 of Olympus 1000",
    provider: "PRAGMATIC PLAY",
    img: `${CDN}/images/exclusivegames/default/exclusive-baji-of-olympus-1000.png`,
    fallback: "linear-gradient(135deg,#7a1e1e 0%,#b8842a 50%,#4a2d10 100%)",
  },
  {
    id: "money-wheel",
    title: "Money Wheel",
    provider: "PRAGMATIC PLAY",
    img: `${CDN}/images/exclusivegames/default/exclusive-money-wheel.png`,
    fallback: "linear-gradient(135deg,#06b6d4 0%,#3b82f6 50%,#7c3aed 100%)",
  },
  {
    id: "aviator",
    title: "Aviator",
    provider: "SPRIBE",
    img: `${CDN}/images/exclusivegames/default/exclusive-aviator.png`,
    fallback: "linear-gradient(135deg,#dc2626 0%,#7a1e1e 100%)",
  },
  {
    id: "super-ace-plus",
    title: "BJ Super Ace+",
    provider: "LUCKY365",
    img: `${CDN}/images/exclusivegames/default/exclusive-bj-super-ace-plus.png`,
    fallback: "linear-gradient(135deg,#ffc933 0%,#b8842a 100%)",
  },
  {
    id: "divas-ace",
    title: "Diva's Ace",
    provider: "YELLOW BAT",
    img: `${CDN}/images/exclusivegames/default/exclusive-divas-ace.png`,
    fallback: "linear-gradient(135deg,#f59e0b 0%,#b45309 100%)",
  },
  {
    id: "fortune-gems-500",
    title: "Fortune Gems 500",
    provider: "JILI",
    img: `${CDN}/images/exclusivegames/default/exclusive-fortune-gems-500.png`,
    fallback: "linear-gradient(135deg,#eab308 0%,#854d0e 100%)",
  },
  {
    id: "fortune-rabbit",
    title: "Fortune Rabbit",
    provider: "PG SOFT",
    img: `${CDN}/images/exclusivegames/default/exclusive-fortune-rabbit.png`,
    fallback: "linear-gradient(135deg,#ec4899 0%,#831843 100%)",
  },
];

// Hot Slots — slot-heavy lineup with Pragmatic / JILI / PG Soft style titles
export const HOT_SLOTS = [
  {
    id: "hs-fortune-tiger",
    title: "Fortune Tiger",
    provider: "PG SOFT",
    img: `${CDN}/images/exclusivegames/default/exclusive-fortune-tiger.png`,
    fallback: "linear-gradient(135deg,#dc2626 0%,#7a1e1e 100%)",
  },
  {
    id: "hs-super-ace-deluxe",
    title: "Super Ace Deluxe",
    provider: "JILI",
    img: `${CDN}/images/exclusivegames/default/exclusive-super-ace-deluxe.png`,
    fallback: "linear-gradient(135deg,#b8842a 0%,#4a2d10 100%)",
  },
  {
    id: "hs-fortune-garuda",
    title: "Fortune Garuda 500",
    provider: "JILI",
    img: `${CDN}/images/exclusivegames/default/exclusive-fortune-garuda-500.png`,
    fallback: "linear-gradient(135deg,#ffc933 0%,#7a5a14 100%)",
  },
  {
    id: "hs-treasures-aztec",
    title: "Treasures of Aztec",
    provider: "PG SOFT",
    img: `${CDN}/images/exclusivegames/default/exclusive-treasures-of-aztec.png`,
    fallback: "linear-gradient(135deg,#19a55c 0%,#0f5e34 100%)",
  },
  {
    id: "hs-boxing-king",
    title: "Boxing King",
    provider: "JILI",
    img: `${CDN}/images/exclusivegames/default/exclusive-boxing-king.png`,
    fallback: "linear-gradient(135deg,#ef4444 0%,#7a1e1e 100%)",
  },
  {
    id: "hs-money-coming",
    title: "Money Coming",
    provider: "JILI",
    img: `${CDN}/images/exclusivegames/default/exclusive-money-coming.png`,
    fallback: "linear-gradient(135deg,#ffc933 0%,#a37100 100%)",
  },
  {
    id: "hs-fortune-gems",
    title: "Fortune Gems 500",
    provider: "JILI",
    img: `${CDN}/images/exclusivegames/default/exclusive-fortune-gems-500.png`,
    fallback: "linear-gradient(135deg,#eab308 0%,#854d0e 100%)",
  },
  {
    id: "hs-fortune-rabbit",
    title: "Fortune Rabbit",
    provider: "PG SOFT",
    img: `${CDN}/images/exclusivegames/default/exclusive-fortune-rabbit.png`,
    fallback: "linear-gradient(135deg,#ec4899 0%,#831843 100%)",
  },
];

// Hot Casino — live-dealer / wheel / arcade flavor lineup
export const HOT_CASINO = [
  {
    id: "hc-money-wheel",
    title: "Money Wheel",
    provider: "PRAGMATIC PLAY",
    img: `${CDN}/images/exclusivegames/default/exclusive-money-wheel.png`,
    fallback: "linear-gradient(135deg,#06b6d4 0%,#3b82f6 50%,#7c3aed 100%)",
  },
  {
    id: "hc-baji-olympus",
    title: "Maxlive88 of Olympus 1000",
    provider: "PRAGMATIC PLAY",
    img: `${CDN}/images/exclusivegames/default/exclusive-baji-of-olympus-1000.png`,
    fallback: "linear-gradient(135deg,#7a1e1e 0%,#b8842a 50%,#4a2d10 100%)",
  },
  {
    id: "hc-divas-ace",
    title: "Diva's Ace",
    provider: "YELLOW BAT",
    img: `${CDN}/images/exclusivegames/default/exclusive-divas-ace.png`,
    fallback: "linear-gradient(135deg,#f59e0b 0%,#b45309 100%)",
  },
  {
    id: "hc-super-ace-plus",
    title: "BJ Super Ace+",
    provider: "LUCKY365",
    img: `${CDN}/images/exclusivegames/default/exclusive-bj-super-ace-plus.png`,
    fallback: "linear-gradient(135deg,#ffc933 0%,#b8842a 100%)",
  },
  {
    id: "hc-aviator",
    title: "Aviator",
    provider: "SPRIBE",
    img: `${CDN}/images/exclusivegames/default/exclusive-aviator.png`,
    fallback: "linear-gradient(135deg,#dc2626 0%,#7a1e1e 100%)",
  },
  {
    id: "hc-golden-genie",
    title: "Golden Genie",
    provider: "FA CHAI",
    img: `${CDN}/images/exclusivegames/default/exclusive-golden-genie.png`,
    fallback: "linear-gradient(135deg,#7c3aed 0%,#a855f7 50%,#ec4899 100%)",
  },
  {
    id: "hc-fortune-tiger",
    title: "Fortune Tiger",
    provider: "PG SOFT",
    img: `${CDN}/images/exclusivegames/default/exclusive-fortune-tiger.png`,
    fallback: "linear-gradient(135deg,#dc2626 0%,#7a1e1e 100%)",
  },
  {
    id: "hc-boxing-king",
    title: "Boxing King",
    provider: "JILI",
    img: `${CDN}/images/exclusivegames/default/exclusive-boxing-king.png`,
    fallback: "linear-gradient(135deg,#ef4444 0%,#7a1e1e 100%)",
  },
];

// New Games — latest arrivals across providers
export const NEW_GAMES = [
  {
    id: "ng-boxing-king",
    title: "Boxing King",
    provider: "JILI",
    img: `${CDN}/images/exclusivegames/default/exclusive-boxing-king.png`,
    fallback: "linear-gradient(135deg,#ef4444 0%,#7a1e1e 100%)",
  },
  {
    id: "ng-divas-ace",
    title: "Diva's Ace",
    provider: "YELLOW BAT",
    img: `${CDN}/images/exclusivegames/default/exclusive-divas-ace.png`,
    fallback: "linear-gradient(135deg,#f59e0b 0%,#b45309 100%)",
  },
  {
    id: "ng-money-coming",
    title: "Money Coming",
    provider: "JILI",
    img: `${CDN}/images/exclusivegames/default/exclusive-money-coming.png`,
    fallback: "linear-gradient(135deg,#ffc933 0%,#a37100 100%)",
  },
  {
    id: "ng-fortune-tiger",
    title: "Fortune Tiger",
    provider: "PG SOFT",
    img: `${CDN}/images/exclusivegames/default/exclusive-fortune-tiger.png`,
    fallback: "linear-gradient(135deg,#dc2626 0%,#7a1e1e 100%)",
  },
  {
    id: "ng-super-ace-deluxe",
    title: "Super Ace Deluxe",
    provider: "JILI",
    img: `${CDN}/images/exclusivegames/default/exclusive-super-ace-deluxe.png`,
    fallback: "linear-gradient(135deg,#b8842a 0%,#4a2d10 100%)",
  },
  {
    id: "ng-golden-genie",
    title: "Golden Genie",
    provider: "FA CHAI",
    img: `${CDN}/images/exclusivegames/default/exclusive-golden-genie.png`,
    fallback: "linear-gradient(135deg,#7c3aed 0%,#a855f7 50%,#ec4899 100%)",
  },
  {
    id: "ng-baji-olympus",
    title: "Maxlive88 of Olympus 1000",
    provider: "PRAGMATIC PLAY",
    img: `${CDN}/images/exclusivegames/default/exclusive-baji-of-olympus-1000.png`,
    fallback: "linear-gradient(135deg,#7a1e1e 0%,#b8842a 50%,#4a2d10 100%)",
  },
  {
    id: "ng-fortune-rabbit",
    title: "Fortune Rabbit",
    provider: "PG SOFT",
    img: `${CDN}/images/exclusivegames/default/exclusive-fortune-rabbit.png`,
    fallback: "linear-gradient(135deg,#ec4899 0%,#831843 100%)",
  },
];

const ExclusiveCard = ({ g, testPrefix, onLaunch }) => {
  const [imgOk, setImgOk] = useState(Boolean(g.img));
  useEffect(() => { setImgOk(Boolean(g.img)); }, [g.img]);
  const showFallback = !g.img || !imgOk;
  return (
  <button
    type="button"
    onClick={() => onLaunch && onLaunch(g.id, g.title, g.provider)}
    data-testid={`${testPrefix}-${g.id}`}
    className="shrink-0 snap-start group relative rounded-2xl overflow-hidden aspect-square w-[38vw] [@media(min-width:640px)]:w-[180px] lg:w-[200px] xl:w-[220px] bg-[#161e2a] transition-transform duration-300 hover:scale-[1.02]"
    style={{ boxShadow: "0 10px 30px rgba(0,0,0,0.45)" }}
  >
    {/* Fallback background so the tile never looks empty if the remote image fails */}
    <div
      aria-hidden
      className="absolute inset-0 flex flex-col items-center justify-center gap-1.5 px-3 text-center"
      style={{ background: g.fallback || "linear-gradient(135deg,#19a55c33 0%,#0a1119 100%)" }}
    >
      {showFallback && (
        <>
          <span className="font-display text-5xl sm:text-6xl text-white/80 leading-none" style={{ letterSpacing: "-0.06em" }}>
            {(g.title || "G").slice(0, 2).toUpperCase()}
          </span>
          <span className="text-[11px] sm:text-[12px] font-bold text-white/85 leading-tight line-clamp-2">
            {g.title}
          </span>
          {g.provider && (
            <span className="text-[9px] uppercase tracking-widest text-white/55 font-semibold">{g.provider}</span>
          )}
        </>
      )}
    </div>
    {g.img && imgOk && (
      <img
        src={g.img}
        alt={g.title}
        loading="lazy"
        referrerPolicy="no-referrer"
        className="relative w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
        onError={() => setImgOk(false)}
      />
    )}
    {/* Hover glow ring */}
    <div
      aria-hidden
      className="absolute inset-0 rounded-2xl pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity"
      style={{
        boxShadow: "inset 0 0 0 2px rgba(25,165,92,0.65), 0 0 32px rgba(25,165,92,0.35)",
      }}
    />
  </button>
  );
};

// Generic re-usable carousel — powers Exclusive Games / Hot Slots / Hot Casino
export const GameShelfCarousel = ({
  title,
  items,
  testId = "shelf",
  moreTo,
}) => {
  const scrollRef = useRef(null);
  const { launchGame, modal } = useGameLaunch();

  const scroll = (dir) => {
    if (!scrollRef.current) return;
    const w = scrollRef.current.clientWidth;
    scrollRef.current.scrollBy({ left: dir * w * 0.8, behavior: "smooth" });
  };

  return (
    <section className="py-6 sm:py-8" data-testid={`${testId}-section`}>
      <div className="flex items-center justify-between mb-4 sm:mb-5 gap-3">
        <h2 className="flex items-center gap-2.5 sm:gap-3 text-lg sm:text-2xl font-bold text-white min-w-0">
          <span className="h-6 sm:h-7 w-1 sm:w-[5px] rounded-full bg-[#19a55c] shrink-0" />
          <span className="truncate">{title}</span>
        </h2>
        <div className="flex gap-1.5 sm:gap-2 shrink-0">
          <button
            type="button"
            onClick={() => scroll(-1)}
            aria-label="previous"
            data-testid={`${testId}-prev`}
            className="h-9 w-11 sm:h-10 sm:w-12 rounded-md bg-[#1a2030] hover:bg-[#222a3d] border border-white/5 flex items-center justify-center text-white/80 hover:text-white transition-colors"
          >
            <ChevronLeft size={18} />
          </button>
          <button
            type="button"
            onClick={() => scroll(1)}
            aria-label="next"
            data-testid={`${testId}-next`}
            className="h-9 w-11 sm:h-10 sm:w-12 rounded-md bg-[#1a2030] hover:bg-[#222a3d] border border-white/5 flex items-center justify-center text-white/80 hover:text-white transition-colors"
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>

      <div
        ref={scrollRef}
        className="flex gap-3 sm:gap-4 overflow-x-auto pb-2 scrollbar-thin snap-x -mx-3 sm:-mx-6 px-3 sm:px-6"
      >
        {items.map((g) => (
          <ExclusiveCard key={g.id} g={g} testPrefix={testId} onLaunch={launchGame} />
        ))}
      </div>

      {moreTo && (
        <div className="flex justify-center pt-5 sm:pt-6">
          <Link
            to={moreTo}
            data-testid={`${testId}-more-btn`}
            className="inline-flex items-center justify-center px-10 sm:px-12 h-10 sm:h-11 rounded-md bg-[#19a55c] hover:bg-[#21c46e] active:bg-[#168f4f] text-white font-bold text-sm sm:text-base shadow-[0_8px_24px_rgba(25,165,92,0.45)] transition-colors"
          >
            More
          </Link>
        </div>
      )}
      {modal}
    </section>
  );
};

// Pre-bound shelves for clean usage in pages.
// Each one fetches its own data + title from /api/public/home-shelves so the operator
// can rename the shelf and curate its games entirely from the admin panel.
//
// Initial `loading` state keeps the shelf invisible until the API responds, so
// the page does NOT flash hardcoded demo games on reload and then hide them
// when the admin shelf turns out to be empty/disabled. Only once the fetch
// completes do we decide whether to render (with admin games) or stay hidden.
function useHomeShelf(slug, fallbackTitle, fallbackItems, fallbackMore) {
  const [data, setData] = useState({
    title: fallbackTitle,
    items: [],
    moreTo: fallbackMore,
    enabled: true,
    loading: true,
  });
  useEffect(() => {
    let cancelled = false;
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    safeFetch(`${BACKEND_URL}/api/public/home-shelves`)
      .then((r) => (r.ok ? r.json() : []))
      .then((shelves) => {
        if (cancelled) return;
        const list = Array.isArray(shelves) ? shelves : [];
        const s = list.find((x) => x.slug === slug);
        if (!s) {
          // Shelf not configured in admin — keep hidden (no flash).
          setData((d) => ({ ...d, items: [], enabled: false, loading: false }));
          return;
        }
        const adminItems = (s.items || []).map((g) => ({
          id: g.id,
          title: g.name,
          provider: g.provider || "",
          img: g.image,
          fallback: "linear-gradient(135deg,#19a55c 0%,#0a3a22 100%)",
        }));
        setData({
          title: s.title || fallbackTitle,
          items: adminItems,
          moreTo: s.more_to || fallbackMore,
          enabled: s.enabled !== false,
          loading: false,
        });
      })
      .catch(() => {
        if (!cancelled) setData((d) => ({ ...d, items: [], enabled: false, loading: false }));
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);
  return data;
}

export const ExclusiveGames = () => {
  const s = useHomeShelf("exclusive", "Exclusive Games", EXCLUSIVE_FEATURED, "/casino");
  if (s.loading || !s.enabled || !s.items.length) return null;
  return <GameShelfCarousel title={s.title} items={s.items} testId="exclusive" moreTo={s.moreTo} />;
};

export const HotSlots = () => {
  const s = useHomeShelf("hot-slots", "Hot Slots", HOT_SLOTS, "/slots");
  if (s.loading || !s.enabled || !s.items.length) return null;
  return <GameShelfCarousel title={s.title} items={s.items} testId="hot-slots" moreTo={s.moreTo} />;
};

export const HotCasino = () => {
  const s = useHomeShelf("hot-casino", "Hot Casino", HOT_CASINO, "/casino");
  if (s.loading || !s.enabled || !s.items.length) return null;
  return <GameShelfCarousel title={s.title} items={s.items} testId="hot-casino" moreTo={s.moreTo} />;
};

export const NewGames = () => {
  const s = useHomeShelf("new-games", "New Games", NEW_GAMES, "/slots");
  if (s.loading || !s.enabled || !s.items.length) return null;
  return <GameShelfCarousel title={s.title} items={s.items} testId="new-games" moreTo={s.moreTo} />;
};
